export const ja = {
  'ad.label': '広告',
  'ad.sponsored_by': '{advertiser} 提供',
  'ad.visit': '訪問',
  'cookies.preferences': 'Cookieの設定',
  'cookies.title': 'あなたのプライバシーは、あなたの管理下に',
  'cookies.description': 'Albambamの動作に必要なストレージを使用します。分析やマーケティングはあなたの許可がある場合のみ有効にします。いつでも取り消せます。詳細は',
  'cookies.privacy_link': 'プライバシーポリシー',
  'cookies.close': '設定を閉じる',
  'cookies.necessary': '必須',
  'cookies.necessary_desc': 'セッション、セキュリティ、言語、基本設定。',
  'cookies.analytics': '分析',
  'cookies.analytics_desc': 'サービス改善のための匿名の利用測定。',
  'cookies.marketing': 'マーケティング',
  'cookies.marketing_desc': '広告のパーソナライズとキャンペーン測定。',
  'cookies.configure': '設定',
  'cookies.reject': '任意を拒否',
  'cookies.save': '選択を保存',
  'cookies.accept': 'すべて許可',
  'lang.selector_label': '言語',
  'lang.changed': '言語を変更しました',
  'nav.home': 'ホーム',
  'nav.categories': 'カテゴリー',
  'nav.shorts': 'ショート',
  'nav.friends': '友達',
  'nav.upload': 'アップロード',
  'nav.profile': 'プロフィール',
  'nav.login': 'ログイン',
  'common.signed_in': 'ログインしました',
  'common.error': 'エラー',
  'topbar.search_placeholder': '動画、クリエイターを検索...',
  'legal.terms': '利用規約',
  'legal.privacy': 'プライバシー',
  'nav.admin': '管理',
  'nav.logout': 'ログアウト',
  'admin.tab.payments': '支払い',
  'admin.payments.title': '支払い',
  'cats.title': 'カテゴリー',
  'cats.all': 'すべて',
  'cats.adult_title': '18+カテゴリー',
  'cats.empty': 'このカテゴリーに動画はありません。',
  'friends.block_confirm': 'この友達をブロックしますか？以降、チャットや友達としての表示ができなくなります。',
  'friends.accepted': '友達になりました！',
  'friends.title': '友達',
  'friends.subtitle': '互いにフォローし合った人だけが友達になり、プライベートチャットができます。',
  'friends.unread_count_label': '未読{n}件',
  'friends.blocked_users_title': 'ブロックしたユーザー',
  'friends.unblock_user': 'ブロック解除',
  'friends.requests_title': 'チャットリクエスト',
  'friends.request_badge': 'リクエスト',
  'friends.request_accept': '承認',
  'friends.request_ignore': '無視',
  'friends.empty_title': 'まだ友達がいません',
  'friends.empty_subtitle': '誰かをフォローし、フォローバックされるとプライベートチャットが解放されます。',
  'friends.attach_image': '写真',
  'friends.shared_video_label': '動画を共有しました',
  'friends.select_conversation': 'チャットを始める友達を選択',
  'friends.block_user': 'ブロック',
  'friends.no_messages_yet': 'まだメッセージがありません。挨拶しましょう！',
  'friends.message_placeholder': 'メッセージを書く...',
  'section.trending': '急上昇',
  'section.shorts': 'ショート',
  'section.for_you': 'あなたへのおすすめ',
  'home.hero.badge': 'Albambamへようこそ',
  'home.hero.title_1': '短い動画。',
  'home.hero.title_2': '本物のクリエイター。',
  'home.hero.subtitle': '見て、共有して、稼ぐ。動画をアップロードし、各カテゴリーで新たな才能を発見しよう。',
  'home.hero.cta_shorts': 'ショートを見る',
  'home.hero.cta_trending': '急上昇',
  'home.shorts.see_all': 'すべて見る',
  'home.empty.title': 'まだ動画がありません',
  'home.empty.subtitle': 'クリエイターがコンテンツをアップロードすると、ここに表示されます。',
  'live.send_diamonds': 'ダイヤモンドを送る',
  'live.buy': '購入',
  'live.chat': 'チャット',
  'live.type_message': 'メッセージを書く...',
  'live.send': '送信',
  'auth.success_google': 'Googleでログインしました',
  'auth.fail_google': '無効なGoogleセッション',
  'auth.success_login': 'ログインしました',
  'auth.success_register': 'アカウントを作成しました',
  'auth.login_tab': 'ログイン',
  'auth.register_tab': 'アカウント作成',
  'auth.email': 'メール',
  'auth.password': 'パスワード',
  'auth.submit_login_loading': 'ログイン中...',
  'auth.submit_login': 'ログイン',
  'auth.name': '名前',
  'auth.submit_register_loading': '作成中...',
  'auth.submit_register': 'アカウント作成',
  'auth.or': 'または',
  'legal.privacy_title': 'プライバシーポリシー',
  'search.title': '「{q}」の検索結果',
  'search.count': '{n}本の動画',
  'search.empty': '結果がありません。',
  'series.load_error': 'シリーズを読み込めませんでした',
  'series.unlocked': 'シリーズがロック解除されました',
  'series.purchase_error': '購入を開始できませんでした',
  'series.restricted': 'アクセス制限',
  'series.configure_access': 'アクセスを設定',
  'series.language_all': 'すべての言語',
  'series.episode_count': '{n}エピソード',
  'series.buy': 'シリーズを購入',
  'series.filter_language': '言語で絞り込む',
  'series.no_episodes': 'まだ公開されているエピソードはありません。',
  'series.episode_number': 'エピソード{n}',
  'legal.terms_title': '利用規約',
  'lang.ca': 'カタロニア語',
  'lang.en': '英語',
  'lang.es': 'スペイン語',
  'lang.fr': 'フランス語',
  'lang.de': 'ドイツ語',
  'lang.it': 'イタリア語',
  'lang.eu': 'バスク語',
  'lang.gl': 'ガリシア語',
  'lang.zh': '中国語',
  'lang.other': 'その他',
  'lang.vi': 'ベトナム語',
  'lang.ja': '日本語',
  'lang.ko': '韓国語',
  'lang.ru': 'ロシア語',
  'lang.ro': 'ルーマニア語',
  'lang.ar': 'アラビア語',
  'lang.tr': 'トルコ語',
  'lang.pl': 'ポーランド語',
  'lang.ms': 'マレー語',
  'lang.ta': 'タミル語',
  'upload.series_title_error': 'シリーズのタイトルを入力してください',
  'upload.series_adult_category_error': 'シリーズの18+カテゴリーを選択してください',
  'upload.series_created': 'シリーズを作成しました',
  'upload.series_create_error': 'シリーズを作成できませんでした',
  'upload.err_file': '有効な動画ファイルを選択してください',
  'upload.err_title': 'タイトルを入力してください',
  'upload.series_select_error': 'シリーズを選択または作成してください',
  'upload.trailer_target_error': 'トレーラーの動画またはシリーズを選択してください',
  'upload.price_error': '最低0.50ユーロの有効な価格を入力してください。',
  'upload.adult_category_error': 'アダルトカテゴリーを選択してください',
  'upload.success': '動画が正常にアップロードされました',
  'upload.title_h': '動画をアップロード',
  'upload.kind': '投稿の種類',
  'upload.kind_video': '単独動画',
  'upload.kind_episode': 'シリーズのエピソード',
  'upload.kind_trailer': 'ショート内の公開トレーラー',
  'upload.series': 'シリーズ',
  'upload.series_select': 'シリーズを選択',
  'upload.episode': 'エピソード',
  'upload.series_new_title': '新しいシリーズのタイトル',
  'upload.series_create': 'シリーズを作成',
  'upload.series_adult': '18+シリーズ',
  'upload.series_premium': 'プレミアムシリーズ',
  'upload.series_adult_category': 'シリーズの18+カテゴリー',
  'upload.series_price': 'エピソードとバンドルの価格（EUR）',
  'upload.trailer_for': 'トレーラーの内容',
  'upload.trailer_select': '動画またはシリーズを選択',
  'upload.video_prefix': '動画',
  'upload.file_label': '動画ファイル（MP4、最大1GB）',
  'upload.file_pick': 'クリックして動画を選択',
  'upload.thumb_label': 'サムネイル（任意）',
  'upload.video_title': 'タイトル',
  'upload.description': '説明',
  'upload.category': 'カテゴリー',
  'upload.is_short': 'ショート（縦型）です',
  'upload.paid_video': '有料動画',
  'upload.adult_content': '18+コンテンツ',
  'upload.video_language': '動画の言語',
  'upload.individual_price': 'この動画を視聴する価格（EUR）',
  'upload.paid_video_help': '視聴者はこの動画のみへの永久アクセスを購入します。最低価格は0.50ユーロです。',
  'upload.adult_category': 'アダルトカテゴリー',
  'upload.uploading': 'アップロード中 {n}%',
  'upload.submit': '動画をアップロード',
  'user.followers': 'フォロワー',
  'user.following': 'フォロー中',
  'user.follow': 'フォロー',
  'user.chat_open': 'チャット',
  'user.request_sent': 'リクエストを送信しました',
  'user.send_message': 'メッセージを送る',
  'user.followers_title': 'フォロワー',
  'user.following_title': 'フォロー中',
  'user.unfollow': 'フォロー解除',
  'user.request_title': 'チャットリクエスト',
  'user.request_subtitle': '送れるメッセージは1件だけです。相手がリクエストを承認すると友達になり、チャットできます。',
  'user.request_placeholder': 'メッセージを書く...',
  'user.request_send': 'リクエストを送る',
  'shorts.login_for_like': 'いいねするにはログイン',
  'watch.share_copied': 'リンクをコピーしました',
  'watch.delete_confirm': 'このコメントを削除しますか？',
  'ad.skip_in': '{n}秒後にスキップ',
  'ad.skip': '広告をスキップ',
  'watch.share': '共有',
  'friends.share_video': '動画を共有',
  'friends.send': '送信',
  'watch.comments': 'コメント',
  'watch.write_comment': 'コメントを書く...',
  'watch.publish': '公開',
  'watch.login_to_comment': 'コメントするにはログインが必要です。',
  'watch.login_btn': 'ログインしてコメント',
  'watch.no_comments': 'まだコメントはありません。',
  'watch.related': '関連動画',
  'nav.trending': '急上昇',
  'friends.follow_option_only_follow': 'フォロー',
  'friends.follow_option_friends': '友達',
  'watch.like': 'いいね',
  'watch.views_short': '{n}回再生',
  'shorts.empty.title': 'まだショートがありません',
  'shorts.empty.subtitle': '短い動画をアップロードしてセクションを始めましょう。',
  'shorts.share': '共有',
  'auth.continue_google': 'Googleで続行',
  'upload.is_premium': 'プレミアム',
  'upload.price': '価格（€）',
  'upload.err_select': '動画を選択してください',
  'profile.upload_btn': '動画をアップロード',
  'profile.tab_videos': 'マイ動画（{n}）',
  'profile.tab_history': '履歴',
  'profile.tab_recos': 'おすすめ',
  'profile.no_videos': 'まだ動画をアップロードしていません。',
  'profile.no_history': 'まだ動画を視聴していません。',
  'profile.no_recos': 'おすすめを受け取るには動画を視聴してください。',
  'profile.likes': 'いいね',
  'profile.views': '回再生',
  'wallet.title': 'ウォレット',
  'wallet.rate_label': 'レート',
  'wallet.min_label': '最低出金額',
  'wallet.amount_label': '出金額',
  'wallet.withdraw_btn': '出金をリクエスト',
  'wallet.history_title': 'リクエスト履歴',
  'wallet.success': 'リクエストを作成しました',
  'wallet.bad_amount': '無効な金額',
  'wallet.per_view': '{rate} {cur}/再生',
  'admin.title': '管理',
  'admin.stats.users': 'ユーザー',
  'admin.stats.videos': '動画',
  'admin.stats.shorts': 'ショート',
  'admin.stats.views': '再生数',
  'admin.tab.videos': '動画',
  'admin.tab.ads': '広告',
  'admin.tab.users': 'ユーザー',
  'admin.tab.withdrawals': '出金',
  'admin.tab.config': '設定',
  'admin.tab.translations': '言語',
  'tbl.title': 'タイトル',
  'tbl.creator': 'クリエイター',
  'tbl.category': 'カテゴリー',
  'tbl.type': 'タイプ',
  'tbl.views': '再生',
  'tbl.likes': 'いいね',
  'tbl.status': '状態',
  'tbl.actions': '操作',
  'tbl.placement': '配置',
  'tbl.advertiser': '広告主',
  'tbl.impressions': '表示',
  'tbl.clicks': 'クリック',
  'tbl.active': '有効',
  'tbl.name': '名前',
  'tbl.email': 'メール',
  'tbl.role': '役割',
  'tbl.wallet': 'ウォレット',
  'tbl.amount': '金額',
  'tbl.date': '日付',
  'tbl.user': 'ユーザー',
  'video.video': '動画',
  'video.short': 'ショート',
  'action.show': '公開',
  'action.hide': '非表示',
  'action.delete_confirm_video': '動画を削除しますか？',
  'ad.create_h': '広告を作成',
  'ad.title_label': 'タイトル',
  'ad.image_label': '画像URL',
  'ad.target_label': 'リンク先URL',
  'ad.advertiser_label': '広告主',
  'ad.placement_label': '配置',
  'ad.placement.banner': 'バナー（サイト）',
  'ad.placement.preroll': 'プレロール（動画の前）',
  'ad.placement.overlay': 'オーバーレイ（動画内）',
  'ad.active': '有効',
  'ad.create_btn': '作成',
  'ad.success_create': '広告を作成しました',
  'ad.delete_confirm': '広告を削除しますか？',
  'users.make_admin': '管理者にする',
  'users.remove_admin': '管理者を解除',
  'wd.approve': '承認',
  'wd.reject': '拒否',
  'wd.mark_paid': '支払い済みにする',
  'wd.empty': 'リクエストはありません',
  'cfg.title': '支払い設定',
  'cfg.rate_label': '再生あたりの支払い（{cur}）',
  'cfg.min_label': '出金の最低額（{cur}）',
  'cfg.currency': '通貨',
  'cfg.save': '保存',
  'cfg.saved': '設定を保存しました',
  'trans.title': '言語と翻訳',
  'trans.intro': '任意の言語コード（例：ja、pt、zh）の翻訳を含むJSONファイルをアップロードします。ファイルはキー→文字列のフラットなマップである必要があります。',
  'trans.code_label': '言語コード（例：ja、pt-BR、zh）',
  'trans.name_label': '表示名（その言語で）',
  'trans.file_label': '翻訳JSONファイル',
  'trans.upload': 'アップロード',
  'trans.uploaded': '翻訳を保存しました',
  'trans.delete': '削除',
  'trans.delete_confirm': 'この言語を削除しますか？',
  'trans.builtin': '組み込み',
  'trans.custom': 'カスタム',
  'trans.empty_custom': 'まだカスタム言語はありません。',
  'common.cancel': 'キャンセル',
  'common.loading': '読み込み中...',
  'common.too_fast': '速すぎます。少しお待ちください',
  'time.few_seconds': '数秒前',
  'time.min': '{n}分前',
  'time.h': '{n}時間前',
  'time.d': '{n}日前',
  'time.w': '{n}週間前',
  'time.mo': '{n}か月前',
  'time.y': '{n}年前',
  'brand.tagline': '短い動画。本物のクリエイター。',
  'live.section': 'ライブ',
  'live.start': 'ライブを開始',
  'live.end': 'ライブを終了',
  'live.join': 'ライブに参加',
  'live.chat_placeholder': 'メッセージを書く...',
  'live.diamond': 'ダイヤモンド',
  'live.buy_access': 'アクセスを購入',
  'live.save_recording': '録画を保存',
};
